<template>
  <v-dialog v-model="dialog" :persistent="loading" max-width="500">
    <v-card tile :disabled="loading">
      <v-card-text>
        <div class="pa-10">
          <h3>SEGURANÇA</h3>
          <div class="mt-5" style="font-weight: bold">
            Dica: Para uma senha mais seugra, use uma senha que contenha números, letras e caracteres especiais.
          </div>

          <div class="text-center mt-5">
            <v-text-field
              v-model="form.password"
              label="Digite sua nova senha"
              :type="showSenha ? 'text' : 'password'"
              color="teal"
              prepend-icon="mdi-lock"
              :append-icon="showSenha ? 'mdi-eye-off' : 'mdi-eye'"
              hint="Senha deve conter no mínimo 6 digitos"
              @click:append="showSenha = !showSenha"
              persistent-hint
              counter
            />

            <div class="mt-7">
              <v-btn
                color="teal"
                tile
                dark
                class="mr-1"
                :loading="loading"
                @click="updatePassword()"
              >
                <v-icon left>mdi-content-save</v-icon>
                Salvar
              </v-btn>

              <v-btn
                tile
                text
                type="password"
                color="grey darken-1"
                class="mr-1"
                @click="show(false)"
              >
                Cancelar
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Auth from '@/services/auth'

export default {
  name: 'DialogAlterarSenha',

  data() {
    return {
      dialog: false,
      loading: false,

      form: {
        password: ''
      },

      showSenha: false
    }
  },

  methods: {
    show(show = true) {
      this.form.password = ''
      this.dialog = show
    },

    async updatePassword() {
      if(!this.form.password) { this.$swal.warning('','Preencha o campo de nova senha'); return }
      if(this.form.password.length < 6) { this.$swal.warning('','Senha deve conter no minimo 6 digitos'); return }

      this.loading = true
      try{
        let resposne = await new Auth().updatePassword(this.form.password)
        this.$swal.success('', resposne)
        this.show(false)
      }catch(error){
        console.error(error)
        this.$swal.error('', error)
      }finally{
        this.loading = false
      }
    }
  }
}
</script>
